<template>
  <div>
    <headBox :title="title" :showBack="fromPage != 'withdraw'"></headBox>
    <div class="settlement-detail">
      <el-tabs v-model="activeName" @tab-click="tabClick" v-if="fromPage == 'withdraw'">
        <el-tab-pane v-for="bean in balanceDates" :key="bean.date" :label="bean.date" :name="bean.date"></el-tab-pane>
      </el-tabs>
      <el-radio-group v-model="activeName2" style="margin-bottom: 15px" @change="tabClick2" v-if="typeList.length > 1">
        <el-radio-button :label="bean.type" v-for="bean in typeList" :key="bean.type">{{ bean.text }}</el-radio-button>
      </el-radio-group>
      <topSearchForm @search="$refs.list.queryList(1)" @export="exportOut" class="select-form-new">
        <el-form :inline="true" class="search-box" label-position="left">
          <el-form-item label="承保时间" prop="createTime" class="items bw">
            <a-range-picker v-model="searchParams.createTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>
          <el-form-item label="产品名称" prop="policyNo" class="items sw">
            <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="" class="items sw">
            <el-input placeholder="请输入姓名/手机号" v-model="searchParams.name" class="input-with-select" clearable>
              <el-select v-model="searchParams.nameType" slot="prepend" placeholder="请选择">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="保单号" prop="policyNo" class="items">
            <el-input v-model="searchParams.policyNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item v-if="[1, 2].includes(userinfo.userLevel * 1) && [1, 2].includes(userinfo.level * 1)" label="">
            <div class="items">
              <el-select
                class="left-select"
                v-model="searchParams.selectedLevel"
                @change="
                  searchParams.mechanId = '';
                  searchParams.policyUserId = '';
                  getChildList();
                "
                placeholder="出单机构"
              >
                <el-option label="出单机构" value="2"></el-option>
                <el-option label="出单员工" value="3"></el-option>
              </el-select>
              <el-select class="right-select" v-if="searchParams.selectedLevel == 2" v-model="searchParams.mechanId" clearable filterable>
                <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
              </el-select>
              <el-select
                class="right-select"
                v-else-if="searchParams.selectedLevel == 3"
                v-model="searchParams.policyUserId"
                filterable
                placeholder="请选择"
                clearable
              >
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item v-else-if="[3].includes(userinfo.userLevel * 1) && [2].includes(userinfo.level * 1)" label="业务员" prop="policyUserId">
            <el-select v-model="searchParams.policyUserId" filterable placeholder="请选择" clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </topSearchForm>

      <div class="info-box">
        <div>
          共<span>{{ statistics.totalPolicyNum || 0 }}</span
          >单
        </div>
        <div>
          实际结算保费：<span>{{ statistics.totalPolicyFeeSum || 0 }}元</span>
        </div>
        <div v-if="showRefund()">
          退保保费：<span>{{ statistics.refundFee || 0 }}元</span>
        </div>
        <div v-if="mechanUserType == 1">
          <em v-if="activityType == 2">活动收入：</em>
          <em v-else-if="activityType == 3">活动奖金：</em>
          <em v-else>实际总收入：</em>
          <span>{{ activeName2 == 5 ? '-' : (statistics.totalIncomeTax || 0) + '元' }}</span>
        </div>
        <div v-if="mechanUserType == 2 || mechanUserType == 3">
          实际总收入：<span>{{ activeName2 == 5 ? '-' : (statistics.totalIncomeTax || 0) + '元' }}</span>
        </div>
        <div v-if="showRefund()">
          退保扣减收入：<span>{{ statistics.refundIncomeTax || 0 }}元</span>
        </div>
        <el-button v-if="showRefund()" type="text" @click="showDetail = true">查看扣减收入保单</el-button>
        <br />
        <div v-if="activeName2 == 5">
          追偿金额：<span>{{ statistics.totalIncomeTax || 0 }}元</span>
        </div>
        <div v-if="activeName2 == 5">{{ statistics.recoveryRule }}</div>
      </div>
      <settlement-list ref="list" :settlementType="activeName2" @getData="getData" :params="searchParams"></settlement-list>

      <el-dialog title="扣减收入保单明细" :visible.sync="showDetail" width="1200px" @opened="lookRefund()">
        <settlement-list ref="modalList" :settlementType="activeName2" :params="searchParams" type="queryRefund"></settlement-list>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import headBox from '@/components/head.vue';
import settlementList from './component/settlementList';
import topSearchForm from '@/components/topSearchForm';
//当前实例组件
export default {
  data: () => ({
    all: {},
    activeName: '',
    activeName2: '',
    selectList: [], //下拉选择
    showDetail: false, //扣减收入保单明细
    mechanUserType: '',
    total: 0,
    date: '', //当前结算日期
    statistics: {},
    fromPage: '',
    policyType: '', //保单类型
    listType: '', //结算类型
    activityType: '', //活动类型
    balanceDates: [], // 结算日期
    typeList: [], // 当前结算日期类型列表
    userList: [], // 保存员工数据
    userinfo: {},
    searchParams: {
      createTime: [],
      selectedLevel: '2',
      nameType: '1',
      mechanId: '',
      policyUserId: ''
    }
  }),
  components: { settlementList, topSearchForm, headBox },
  computed: {
    title() {
      if (this.fromPage == 'withdraw') {
        return this.$route.query.title;
      } else if (this.date) {
        return `${this.date}结算保单明细`;
      } else {
        return '结算保单明细';
      }
    }
  },
  mounted() {
    this.userinfo = this.$tools.getLocal('userinfo');
    if (this.$route.query.detailId) {
      this.searchParams.balanceIds = [this.$route.query.detailId];
    } else if (this.$route.query.balanceIds) {
      this.searchParams.balanceIds = this.$route.query.balanceIds.split(',');
    }
    this.fromPage = this.$route.query.fromPage;
    this.date = this.$route.query.text;
    this.policyType = this.$route.query.policyType;
    this.listType = this.$route.query.type;
    this.activityType = this.$route.query.activityType;
    this.getBalanceDateList();
    if (this.userinfo.level == 1 || (this.userinfo.level == 2 && this.userinfo.userLevel == 2)) {
      this.searchParams.selectedLevel = '2';
      this.getChildList();
      this.getUserList();
    } else if (this.userinfo.level == 2) {
      this.searchParams.selectedLevel = '3';
      this.getUserList();
    }
    this.$tools.getall(data => {
      this.all = data;
    });
  },
  methods: {
    // 获取员工列表
    getUserList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {}
      }).then(data => {
        this.userList = data.data;
      });
    },
    exportOut: function () {
      const params = this.$refs.list.getParams();
      if (params.balanceIds) {
        params.balanceIds = params.balanceIds.join('$');
      }
      var url = this.$config.api_root + '/master/policy/export/policyIncomes?' + this.$tools.urlEncode(params);
      console.log(url);
      window.open(url);
    },
    // 获取结算日期列表
    getBalanceDateList() {
      this.$http({
        url: '/master/policy/queryBalancePolicyTabs',
        type: 'PUT',
        params: {
          balanceIds: this.searchParams.balanceIds
        }
      }).then(res => {
        const dateMap = res.data;
        for (const date in dateMap) {
          if (Object.hasOwnProperty.call(dateMap, date)) {
            const typeMap = this.all.BALANCE_TYPE;
            const typeList = dateMap[date].map(type => ({
              type,
              text: typeMap[type]
            }));
            this.balanceDates.push({
              date,
              typeList
            });
          }
        }
        this.activeName = this.balanceDates[0].date;
        this.tabClick();
      });
    },
    tabClick() {
      this.searchParams.balanceDate = this.activeName;
      const data = this.balanceDates.find(item => item.date == this.activeName);
      this.typeList = data.typeList;
      this.activeName2 = data.typeList[0].type;
      this.tabClick2(this.activeName2);
    },
    tabClick2() {
      this.searchParams.type = this.activeName2;
      this.$refs.list.queryList(1);
    },
    back() {
      history.go(-1);
    },
    // 获取机构/员工列表
    getChildList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          includeFirst: '1'
        }
      })
        .then(res => {
          this.selectList = res.data;
        })
        .catch(e => {});
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data) {
      let val = data.map(item => {
        if (item.children.length == 0) {
          item.children = '';
        } else {
          this.handleDeptTree(item.children);
        }
        return item;
      });
      return val;
    },
    // 是否显示扣减相关
    showRefund() {
      if (this.mechanUserType == 1 && this.statistics.refundIncomeTax > 0) {
        return true;
      } else if (this.mechanUserType == 2 && this.statistics.refundRealIncomes > 0) {
        return true;
      }
      return false;
    },
    lookRefund() {
      this.$refs.modalList.queryList(1);
    },
    getData(data) {
      this.mechanUserType = data.mechanUserType;
      this.statistics = data.statistics;
      this.total = data.total;
    }
  }
};
</script>
<style lang="scss">
@import './settlementDetail.scss';
</style>
